export const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3333";
export const GOOGLE_CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID;
